import { type SecondaryCategoryConfig } from '@webapp/platform/organization-management/entities/SecondaryCategoryConfig'
import { useReportAccessSecondaryCategoryListPresenter } from './useReportAccessSecondaryCategoryListPresenter'
import { ReportAccessSecondaryCategoryListView } from '../../views/ReportAccessSecondaryCategoryListView'

export interface IReportAccessSecondaryCategoryListPresenterProps {
  primaryCategoryId: number
  primaryCategoryName: string
  selectedSecondaryCategoryId: number | undefined
  isAllSecondaryCategoriesSelected: boolean
  onSelect: (config: SecondaryCategoryConfig) => void
  onToggleSelectAll: () => void
}

export const ReportAccessSecondaryCategoryListPresenter = ({
  primaryCategoryId,
  primaryCategoryName,
  selectedSecondaryCategoryId,
  isAllSecondaryCategoriesSelected,
  onSelect,
  onToggleSelectAll,
}: IReportAccessSecondaryCategoryListPresenterProps) => {
  const {
    data: { secondaryCategoryConfigs, currentPage, numPages, searchTerm },
    states: { isLoading, isSelectAllBarVisible },
    methods: {
      onSearchChange,
      onPageChange,
      onRowClick,
      onToggleSelectAll: handleToggleSelectAll,
    },
  } = useReportAccessSecondaryCategoryListPresenter({
    primaryCategoryId,
    selectedSecondaryCategoryId,
    isAllSecondaryCategoriesSelected,
    onSelect,
    onToggleSelectAll,
  })

  return (
    <ReportAccessSecondaryCategoryListView
      primaryCategoryName={primaryCategoryName}
      secondaryCategoryConfigs={secondaryCategoryConfigs}
      selectedSecondaryCategoryId={selectedSecondaryCategoryId}
      isAllSecondaryCategoriesSelected={isAllSecondaryCategoriesSelected}
      isSelectAllBarVisible={isSelectAllBarVisible}
      searchTerm={searchTerm}
      onSearchChange={onSearchChange}
      currentPage={currentPage}
      numPages={numPages}
      onPageChange={onPageChange}
      isLoading={isLoading}
      onRowClick={onRowClick}
      onToggleSelectAll={handleToggleSelectAll}
    />
  )
}

ReportAccessSecondaryCategoryListPresenter.displayName =
  'ReportAccessSecondaryCategoryListPresenter'
